import { render, staticRenderFns } from "./PlayVideo.vue?vue&type=template&id=6d25edfc&scoped=true&"
import script from "./PlayVideo.vue?vue&type=script&lang=js&"
export * from "./PlayVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlayVideo.vue?vue&type=style&index=0&id=6d25edfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25edfc",
  null
  
)

export default component.exports